import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { AlfaleasingCalculatorWithTabOptions as Component } from '../alfaleasing-calculator-with-tab-options';
import type { TAlfaleasingCalculatorWithTabOptions, IDeps } from '../models';

import styles from './desktop.css';

// eslint-disable-next-line styler/check-styler
export const AlfaleasingCalculatorWithTabOptionsDesktop = createWidget<
    IDeps,
    TAlfaleasingCalculatorWithTabOptions
>({ styles, isMobileView: false })(Component);
